import { useEffect } from "react";
import { DoorOpen } from "lucide-react";

const exitNow = () => {
  document.title = "Weather forecast and current conditions";
  try {
    window.location.replace("https://weather.com");
  } catch {
    window.location.href = "https://weather.com";
  }
};

export const QuickExit = () => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") exitNow();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <button
      data-testid="quick-exit-button"
      onClick={exitNow}
      aria-label="Quick exit: leave this site immediately"
      title="Leave this site immediately (or press Escape)"
      className="fixed top-3 right-3 z-[60] inline-flex items-center gap-1.5 rounded-full bg-stone-900 hover:bg-stone-700 text-white px-4 py-2 text-xs font-semibold shadow-lg transition-colors duration-150"
    >
      <DoorOpen className="h-3.5 w-3.5" />
      Quick exit
    </button>
  );
};
